import { render } from "./Aloqa.vue?vue&type=template&id=49ebdce6&scoped=true"
import script from "./Aloqa.vue?vue&type=script&lang=js"
export * from "./Aloqa.vue?vue&type=script&lang=js"

import "./Aloqa.vue?vue&type=style&index=0&id=49ebdce6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49ebdce6"]])

export default __exports__